const clickOutsideOptions = {
  props: {
    /**
     * A query-selector or an array of query-selectors
     * to be ignored when clicking outside an element
     */
    excludeClickOutsideSelectors: {
      type: [String, Array],
      default: () => []
    }
  },
  computed: {
    clickOutsideOptions() {
      const excludedQuerySelectors = Array.isArray(this.excludeClickOutsideSelectors) ? this.excludeClickOutsideSelectors : [this.excludeClickOutsideSelectors];
      return { ignore: excludedQuerySelectors };
    }
  }
};
export {
  clickOutsideOptions as default
};
